import api from './api';

// Get current user info from localStorage
export const getCurrentUser = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    
    // Try to get full user data from localStorage first
    const userData = localStorage.getItem('user');
    const payload = JSON.parse(atob(token.split('.')[1]));
    
    const basicUser = {
      userId: payload.userId,
      _id: payload.userId, // Add _id alias for userId
      role: payload.role
    };
    
    // If we have stored user data, merge it with token data
    if (userData) {
      try {
        const parsedUserData = JSON.parse(userData);
        return {
          ...basicUser,
          ...parsedUserData,
          _id: parsedUserData._id || parsedUserData.id || payload.userId || basicUser.userId // Multiple fallbacks for _id
        };
      } catch (parseError) {
        console.error('Error parsing stored user data:', parseError);
        return basicUser;
      }
    }
    
    return basicUser;
  } catch (error) {
    console.error('Error parsing token:', error);
    return null;
  }
};

// Fetch users based on current user's role
export const fetchUsers = async (includeStats = false) => {
  try {
    const currentUser = getCurrentUser();
    
    if (!currentUser) {
      throw new Error('No authenticated user');
    }

    let endpoint = '/users/list'; // Default for members
    
    // Admin and leaders can access full users endpoint
    if (currentUser.role === 'admin' || currentUser.role === 'leader') {
      endpoint = '/users';
    }

    const response = await api.get(endpoint);
    
    // Handle different response formats
    if (response.data && response.data.users && Array.isArray(response.data.users)) {
      return response.data.users;
    } else if (Array.isArray(response.data)) {
      return response.data;
    } else {
      console.warn('Users data format unexpected:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching users:', error);
    return [];
  }
};

// Fetch users summary (admin only)
export const fetchUsersSummary = async () => {
  try {
    const currentUser = getCurrentUser();
    
    if (currentUser?.role !== 'admin') {
      throw new Error('Unauthorized: Admin access required');
    }

    const response = await api.get('/users/summary');
    return response.data;
  } catch (error) {
    console.error('Error fetching users summary:', error);
    return null;
  }
};

// Fetch users for assignment/editing (role-based filtering)
export const fetchUsersForAssignment = async () => {
  try {
    const response = await api.get('/users/for-assignment');
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error('Error fetching users for assignment:', error);
    return [];
  }
};

const userService = {
  getCurrentUser,
  fetchUsers,
  fetchUsersSummary,
  fetchUsersForAssignment
};

export default userService; 